module.exports = __webpack_public_path__ + "img/tabar_withdrawBankCard1.35fd490b.png";